/**
 * 引文服务
 * 从 AZ_AI_MVR_H5/src/services/conCitation.ts 迁移
 */
import request from "../../utils/request";

/** 批量创建引文 */
export function saveBulkCreateConCitation(
  items: Array<{
    replyId: string;
    citationId: string;
    content: string;
    documentId?: string;
    position?: string;
  }>,
) {
  return request.post("/project/concitation/savebulkcreate", items).then((r) => r.data);
}

/** 创建单条引文 */
export function createConCitation(data: Record<string, any>) {
  return request.post("/project/concitation/create", { Entity: data }).then((r) => r.data);
}

/** 搜索引文 */
export function searchConCitation(params: Record<string, any>) {
  return request.post("/project/concitation/searchconcitation", params).then((r) => r.data);
}
